'use es6';

import { getApiClient } from './apiClient';
export const getThemeContents = bucketKey => getApiClient().get(`/product/marketplace/v2/zip/s3/${encodeURIComponent(bucketKey)}`);